<div [ngClass]= "errorType">
  <h4>{{errorTitle}}</h4>
  <p>{{errorMessage}}</p>
</div>